// note -> deprecated (removed Modernizr transform)
export const transEndEventName = 'transitionend';
export const transStartEventName = 'transitionstart';
export const animEndEventName = 'animationend';
export const animStartEventName = 'animationstart';